/**
 * Project Tasks Kanban Configuration
 *
 * Configuration for the Project Tasks kanban board using the global Kanban component.
 */

import { KanbanConfig } from '../types';
import { ProjectTask, ProjectTaskStatus } from 'shared/types/renovation';
import { projectTaskColumns } from 'screens/renovationProject/config/projectTaskStatusConfig';

/**
 * Project Tasks Kanban Configuration
 *
 * This config defines how the Project Tasks kanban should look and behave:
 * - Uses status columns from projectTaskStatusConfig (single source of truth)
 * - Shows count per column
 * - Scrollable columns for better handling of many tasks
 * - Tooltips enabled for status explanations
 */
export const projectTasksKanbanConfig: KanbanConfig<ProjectTask, ProjectTaskStatus> = {
  // Column definitions from existing projectTaskStatusConfig
  columns: projectTaskColumns,

  // Get the status for a project task
  getItemStatus: (task: ProjectTask) => task.status,

  // Show count badge per column
  showCount: true,

  // Show add button per column
  showAddButton: true,

  // Empty state configuration
  emptyState: {
    message: 'Geen taken',
  },

  // Columns are scrollable (they have a max height)
  scrollableColumns: true,

  // Enable tooltips for column headers
  tooltips: true,

  // Max height for scrollable columns
  maxHeight: 'max-h-[600px]',
};
